import React, { useState } from "react";
import PropTypes from "prop-types";
import CommonMenuEntries from "./CommonMenuEntries";
import AnalyticsLink from "./AnalyticsLink";
import AdminMenuEntries from "./AdminMenuEntries";
import ActivityCount from "./ActivityCount";
import CommentModerationLink from "./CommentModerationLink";

const AccountMenu = ({ user, adminActions }) => {
  if (!user) { return null; }

  const [menuVisible, setMenuVisible] = useState(false);

  const topbarDropdownClassNames = ["topbar-account-nav", "topbar-dropdown", "topbar-module"];

  if (menuVisible) {
    topbarDropdownClassNames.push("open");
  }

  return (
    // TODO: rework this dom structure, may need style changes.
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <nav className={topbarDropdownClassNames.join(" ")} onClick={() => setMenuVisible(!menuVisible)}>
      <ActivityCount value={user.newsFeedCount} />

      <div className="menu-button-contents">
        <span className="menu-button-text">
          <span className="menu-button-name">{user.name}</span>
          <i className="icon-caret-down drop-down-caret" />
        </span>
        <img width="170" height="170" alt="" src={user.avatar} />
      </div>

      <ul className="menu">
        <AnalyticsLink visible={user.hasAnalyticsAccess} />
        <CommentModerationLink
          visible={user.hasCommentModerationAccess}
          newsFeedCount={user.newsFeedCount}
        />
        <CommonMenuEntries user={user} />
        <AdminMenuEntries adminActions={adminActions} />
      </ul>
    </nav>
  );
};

AccountMenu.defaultProps = {
  user: undefined,
};

AccountMenu.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
    newsFeedCount: PropTypes.number.isRequired,
    hasAnalyticsAccess: PropTypes.bool.isRequired,
    hasCommentModerationAccess: PropTypes.bool.isRequired,
  }),
  adminActions: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
  })).isRequired,
};

export default AccountMenu;
